import React, { useEffect, useState } from 'react';
import {
  FaAngleDoubleUp,
  FaAngleDoubleDown,
  FaMapMarkerAlt,
  FaComments,
  FaShare,
} from 'react-icons/fa';
import { FaCartPlus, FaHeart } from 'react-icons/fa';
import TOUR_LINK_KEYS from '../constants/OneTour';
import DEPART_DIC from '../constants/DepartDic';
import {
  beautyReefHotelList,
  noWindHotelList,
} from '../constants/EgypetCollectionHotelsList';
import formatNumber from '../utils/formatNumber';
import OneTouristTour from './OneTouristTour';
import TouristGroupedByRoomTours from './TouristGroupedByRoomTours';
import FlightsClock from '../../../shared/components/FlightsClock';
import moment from 'moment';
import $ from 'jquery';
import md5 from 'md5';
import LoginForm from '../../../shared/lib/LoginForm';
import checkLikedOrAddedToCardTour from '../../../shared/lib/checkLikedOrAddedToCardTour';
import getDiscount from '../utils/getDiscount';
import { ShareModal } from '../components/ShareModal/ShareModal';
import InExcludedDirections from '../utils/checkInExcludedDirections';
import {
  CURRENCY_CLASSES,
  DEFAULT_CURRENCY_CLASS,
  CURRENCY_MAP_ICON,
} from '../constants/CurrencyClasses';
import { TOUR_ROW_MAP } from '../constants/TourRowMap';
import { MEAL_TITLES } from '../constants/MealTitles';
import { TYPE_ROOM_MAP } from '../constants/TypeRoomMap';
import { AiFillLike } from 'react-icons/ai';
import { IoCloseCircle, IoWarning } from 'react-icons/io5';
import { LuPlaneTakeoff } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import { BsFillLightningChargeFill } from 'react-icons/bs';

const OneTouristHotelMobileView = ({
  row,
  departure,
  request_model,
  recomend = false,
  discount,
  likes,
  carts,
  isAuth,
  tourData,
  onContinue,
  onCartUpdate,
  sort,
  onSort,
  getHotelInfo,
  hasGeograftourReviews,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [geoKeyLikedTour, setGeoKeyLikedTour] = useState(null);
  const [geoKeyAddedToCartTour, setGeoKeyAddedToCartTour] = useState(null);
  const [isAuthSuccess, setIsAuthSuccess] = useState(isAuth);
  const [loginForm, setLoginForm] = useState(false);
  const [tourToShare, setTourToShare] = useState(null);
  const [roomList, setRoomList] = useState([]);
  const [groupedTours, setGroupedTours] = useState([]);
  const [toursLength, setToursLength] = useState(0);
  const [isHotelCardHidden, setHotelCardHidden] = useState(false);

  const toggleTours = () => {
    setOpen(!isOpen);
  };

  const handleContinue = (e) => {
    $(e.target).hide();
    onContinue();
  };

  const oneTour = (item) => {
    if (
      InExcludedDirections(
        item.operatorcode,
        item.departurecode,
        item.countrycode,
        item.regioncode
      )
    ) {
      return;
    }

    const depart_id = departure;
    const depart_name = DEPART_DIC[departure]?.name;

    const row = {
      provider: 'tourvisor',
      request_id: '',
      source_id: '',
      hash: '',
      currency_class: 'rouble',
      base_tour: 1,
      depart_id,
      depart_name,
    };
    Object.keys(item).forEach((key) => {
      var new_key = TOUR_ROW_MAP[key] || key;
      row[new_key] = item[key] || '';
    });

    row.offer_id = item.tours.tour[0].tourid;
    row.place_id = item.tours.tour[0].placement;
    row.place_name = item.tours.tour[0].placement;
    row.room_id = item.tours.tour[0].room;
    row.room_name = item.tours.tour[0].room;
    row.oper_id = item.tours.tour[0].operatorcode;
    row.oper_name = item.tours.tour[0].operatorname;
    row.price = parseInt(item.price, 10);
    row.hot_price = 0;
    row.child = row.child === '' ? 0 : row.child;
    row.ages = '';
    if (parseInt(row.adult, 10) === 2 && parseInt(row.child, 10) === 0) {
      row.show_half = true;
      row.hot_price = Math.ceil(row.price / 2);
    }
    if (item.tours.tour[0].mealcode === 9067) {
      row.meal_full = 'Питание по программе экскурсионного тура';
    } else {
      row.meal_full = MEAL_TITLES[item.tours.tour[0].meal] || '';
    }
    row.meal_id = item.tours.tour[0].mealcode;
    row.meal_name = item.tours.tour[0].meal;
    row.star_name = row.star_id + '*';
    row.dt1 = item.tours.tour.length
      ? item.tours.tour[0].flydate
      : '25.04.2024';
    row.nights = item.tours.tour[0].nights;
    row.dt2 = moment(row.dt1, 'DD.MM.YYYY')
      .add(parseInt(item.tours.tour[0].nights, 10), 'days')
      .format('DD.MM.YYYY');

    row.volatility = '';
    row.hotel_link = row.hotel_link;
    row.currency_class =
      CURRENCY_CLASSES[item.currency] || DEFAULT_CURRENCY_CLASS;

    row.adult = request_model['adults'];
    row.child = request_model['child'];
    row.ages = Array.isArray(request_model['ages'])
      ? request_model['ages'].join(',')
      : '';

    const discountParams = getDiscount(
      {
        depart: row.depart_id,
        country: row.country_id,
        oper: row.oper_id,
        region: row.town_id,
        subregion: row.subregion_id,
        hotel: row.hotel_id,
        adult: row.adult,
        child: row.child,
        meal: row.meal_id,
        dt: row.dt1,
        currency: row.currency,
      },
      discount
    );

    row.text = '';
    row.discount = false;

    if (discountParams && discountParams.active) {
      if (discountParams.proc > 0) {
        row.price = Math.ceil((row.price * (100 - discountParams.proc)) / 100);
        row.volatility = discountParams.proc;
      } else if (discountParams.currency_discount > 0) {
        row.price = row.price - discountParams.currency_discount;
      }
      row.text = discount.text;
      row.discount = true;
    }

    row.comment = ''; //FindTourComment(item);

    row.full_price = row.price;
    row.full_price_label = formatNumber(row.full_price);
    row.claim_mark = 'customer'; //(!!window.CLAIM_MARK) ? CLAIM_MARK : 'customer';
    row.credit = false;

    row.promo = /promo|промо/i.test(item.tours.tour[0].tourname) ? 1 : 0;

    row.hotel_adult = item.tours.tour[0].adults;
    row.hotel_child = item.tours.tour[0].child;

    function objectToQueryString(obj) {
      return Object.keys(obj)
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
        )
        .join('&');
    }

    // Формируем объект, содержащий только указанные свойства из объекта row
    const filteredRow = {};
    TOUR_LINK_KEYS.forEach((key) => {
      if (row.hasOwnProperty(key)) {
        filteredRow[key] = row[key];
      }
    });

    // Преобразуем объект filteredRow в строку запроса URL
    const tourLink = objectToQueryString(filteredRow);

    return {
      row: row,
      tour_link: tourLink,
      request_id: '',
      additional: '',
    };
  };

  const parseOneHotelTours = (item) => {
    const hotel = oneTour(item);
    return hotel;
  };

  const setTourLike = () => {
    if (isAuthSuccess || isAuth) {
      // тур не залайкан, отправляем данные и получаем geokey
      let like_data = tourData;
      let tour_hash = md5(like_data);
      like_data += `&like=true&tour_hash=${tour_hash}`;
      if (!geoKeyLikedTour) {
        $.ajax({
          url: 'https://cabinet.geograftour.com/orders/add-like-api/',
          data: like_data,
          dataType: 'jsonp',
          jsonp: 'callback',
          error: function (jqxhr) {
            console.log('Failed to load resource', jqxhr);
          },
          success: function (data) {
            if (data.geokey) {
              setGeoKeyLikedTour(data.geokey);
            }
            // обновить панель на форме
            onCartUpdate();
          },
        });
      } else {
        // тур залайкан, значит есть geokey который отправим на удаление
        $.ajax({
          url: `https://cabinet.geograftour.com/orders/remove-json-tour/?geokey=${geoKeyLikedTour}`,
          dataType: 'jsonp',
          jsonp: 'callback',
          error: function (jqxhr) {
            console.log('Failed to load resource like tour remove', jqxhr);
            setGeoKeyLikedTour(null);
            console.warn('SET GEOKEY NULL');
            onCartUpdate();
          },
          success: function (data) {
            // обновить панель на форме
            setGeoKeyLikedTour(null);
            console.warn('SET GEOKEY NULL');
            onCartUpdate();
          },
        });
      }
    } else {
      // alert('Необходимо авторизоваться');
      setLoginForm(true);
    }
  };

  const setTourToCart = () => {
    if (isAuthSuccess || isAuth) {
      let card_data = tourData;
      const tour_hash = md5(card_data);
      card_data += `&cart=true&tour_hash=${tour_hash}`;
      if (!geoKeyAddedToCartTour) {
        $.ajax({
          url: 'https://cabinet.geograftour.com/orders/add-cart-api/',
          data: card_data,
          dataType: 'jsonp',
          jsonp: 'callback',
          error: function (jqxhr) {
            console.log('Failed to load resource', jqxhr);
          },
          success: function (data) {
            if (data.geokey) {
              console.log('добавляем тур в корзину');
              setGeoKeyAddedToCartTour(data.geokey);
            }
            onCartUpdate();
          },
        });
      } else {
        $.ajax({
          url: `https://cabinet.geograftour.com/orders/remove-json-tour/?geokey=${geoKeyAddedToCartTour}&cart=true`,
          dataType: 'jsonp',
          jsonp: 'callback',
          error: function (jqxhr) {
            setGeoKeyAddedToCartTour(null);
            onCartUpdate();
          },
          success: function (data) {
            // обновить панель на форме
            setGeoKeyAddedToCartTour(null);
            onCartUpdate();
          },
        });
      }
    } else {
      setLoginForm(true);
    }
  };

  const handleAuthSuccess = () => {
    // при успешной авторизации
    setIsAuthSuccess(true);
    onCartUpdate();
  };

  function handleOfficeSave() {
    localStorage.removeItem('officeId');
    if (window.location.pathname.includes('office')) {
      const { pathname } = window.location;
      const officeId = pathname
        .substring(pathname.indexOf('/office/') + '/office/'.length)
        .replace('/', '');
      localStorage.setItem('officeId', officeId);
    }
    // установить officeId со страницы отзыва на отель от определенного агента
    if (window.AGENT_OFFICE_ID) {
      localStorage.setItem('officeId', window.AGENT_OFFICE_ID);
    }
  }

  const handleSeen = () => {
    handleOfficeSave();
    let data = tourData;
    const tour_hash = md5(data);
    data += `&cart=false&like=false&tour_hash=${tour_hash}`;
    $.ajax({
      url: `https://cabinet.geograftour.com/orders/add-seen-api/`,
      data: data,
      dataType: 'jsonp',
      jsonp: 'callback',
      error: function (jqxhr) {
        console.log('Failed to load resource seen tour', jqxhr);
        onCartUpdate();
      },
      success: function (data) {
        // обновить панель на форме
        onCartUpdate();
      },
    });
  };

  function groupToursByRoom(tourList) {
    if (tourList.length !== toursLength) {
      setToursLength(tourList.length);
      let roomList = [];
      tourList.forEach((tour) =>
        roomList.includes(tour.room) ? false : roomList.push(tour.room)
      );
      setRoomList(roomList);
      let group = {};
      for (let i = 0; i < tourList.length; i++) {
        let tour = tourList[i];

        if (group.hasOwnProperty(tour.room)) {
          group[tour.room].push(tour);
        } else {
          group[tour.room] = [tour];
        }
      }
      setGroupedTours(group);
    }
  }

  function hideHotelCard() {
    setHotelCardHidden(!isHotelCardHidden);
  }

  useEffect(() => {
    const tourId = row.tours.tour[0].tourid;
    const likedTour = checkLikedOrAddedToCardTour(tourId, likes);
    if (likedTour) {
      setGeoKeyLikedTour(likedTour);
    }
  }, [likes]);

  useEffect(() => {
    const tourId = row.tours.tour[0].tourid;
    const addedToCartTour = checkLikedOrAddedToCardTour(tourId, carts);

    if (addedToCartTour) {
      setGeoKeyAddedToCartTour(addedToCartTour);
    }
  }, [carts]);

  useEffect(() => {
    groupToursByRoom(row.tours.tour);
  }, [row.tours.tour]);

  const row_fix = parseOneHotelTours(row);

  const {
    hotelname,
    hotelrating,
    picturelink,
    hotelcode,
    hotelstars,
    countryname,
    regionname,
    tours,
    hoteldescription,
    currency,
  } = row;

  function textNights(nights) {
    if (nights === 1) {
      return `${nights} ночь`;
    }
    if (nights < 5) {
      return `${nights} ночи`;
    }
    if (nights > 4) {
      return `${nights} ночей`;
    }
  }

  return (
    <>
      <article
        className={`hotel-card ${
          isHotelCardHidden ? 'hotel-card_hidden' : ''
        } ${recomend}`}
      >
        <div className="hotel-card__image">
          {hotelrating > 0 && (
            <div className="hotel-card__rating" title="Средний рейтинг отеля">
              {hotelrating > 0 ? parseFloat(hotelrating, 2) : ''}
            </div>
          )}
          <div className={'hotel-card__badges'}>
            {row_fix.row.promo ? (
              <div className="hotel-card__promo-mobile">ПРОМО</div>
            ) : null}
            {!!recomend ? (
              <div className="tour__geolike tour__badge">
                <AiFillLike title="Рекомендуем" />
              </div>
            ) : null}
          </div>
          <img
            className="hotel__image"
            id={hotelcode}
            src={picturelink}
            alt={`Фото отеля ${hotelname}`}
            onClick={() => {
              handleSeen();
              getHotelInfo(hotelcode);
            }}
            loading="lazy"
          />
          <div className="hotel__social-bar">
            <FaShare
              title={'Поделиться туром'}
              className="hotel__social-btn"
              onClick={(e) => {
                e.preventDefault();
                setOpenModal(true);
                setTourToShare(row_fix.row);
              }}
            />
            <FaComments
              onClick={() => {
                handleSeen();
                getHotelInfo(hotelcode, 3);
              }}
              title="Отзывы туристов"
              className="hotel__social-btn"
            />
            <FaMapMarkerAlt
              onClick={(e) => {
                handleSeen();
                getHotelInfo(hotelcode, 1);
              }}
              title="Отель на карте"
              className="hotel__social-btn"
            />
            {!!hasGeograftourReviews ? (
              <div
                className="tour__georeview"
                title="Отзывы от Географии"
                onClick={() => {
                  handleSeen();
                  getHotelInfo(row.hotelcode, 2);
                }}
              >
                <img
                  src="https://geograftour.com/static/index/img/geoclient/geo-simple-logo.webp"
                  alt=""
                  loading="lazy"
                />
              </div>
            ) : null}
            <IoCloseCircle
              title="Скрыть данный отель"
              className="hotel-card__close-btn"
              onClick={hideHotelCard}
            ></IoCloseCircle>
          </div>
        </div>
        <div className="hotel-card__body">
          <div className="hotel__short-info">
            <div
              className="hotel__title"
              id={hotelcode}
              onClick={(e) => {
                handleSeen();
                getHotelInfo(hotelcode);
              }}
            >
              {hotelstars > 0 ? <span>{hotelstars}* </span> : null}
              {hotelname}
            </div>
            <span className="hotel-card__region">
              {countryname}, {regionname}
            </span>
            <span className="hotel-card__departure">
              <LuPlaneTakeoff />
              <b>
                {DEPART_DIC[departure]?.id !== 99 ? 'Из' : ''}{' '}
                {DEPART_DIC[departure]?.name_from}{' '}
              </b>
            </span>
            <div className="hotel__badge-feature">
              {row_fix.row.country_id === 1 &&
              beautyReefHotelList.includes(+hotelcode) ? (
                <span style={{ background: '#fc6464' }}>Красивый риф</span>
              ) : null}
              {row_fix.row.country_id === 1 &&
              noWindHotelList.includes(+hotelcode) ? (
                <span style={{ background: '#009abc' }}>Бухта без ветра</span>
              ) : null}
            </div>
            <div className="hotel__tour-flight-info">
              <span style={{ fontSize: '12px' }}>
                С {moment(tours.tour[0].flydate, 'DD.MM.YYYY').format('DD MMM')}
                , на <b>{textNights(tours.tour[0].nights)}</b>
              </span>
              {String(departure) !== '99' ? (
                <>
                  <FlightsClock tour_id={row.tours.tour[0].tourid} />
                  {tours.tour[0].regular === 1 ? (
                    <span className="tour-flight">
                      <IoWarning className="tour-flight__warning" />
                      <b>Рейс регулярный, возможны доплаты</b>
                    </span>
                  ) : (
                    <span className="">Чартер</span>
                  )}

                  {tours.tour[0].fuelcharge ? (
                    <div>
                      Включен топливный сбор:{' '}
                      <span>
                        {tours.tour[0].fuelcharge} {tours.tour[0].currency}
                      </span>
                    </div>
                  ) : null}
                </>
              ) : null}
            </div>
            <div className="hotel__room-food-info">
              {TYPE_ROOM_MAP[row_fix.row.place_name]
                ? TYPE_ROOM_MAP[row_fix.row.place_name]
                : row_fix.row.place_name}{' '}
              {row_fix.row.meal_id === 9067
                ? `| ${row_fix.row.meal_full}`
                : `| ${row_fix.row.meal_name}, ${row_fix.row.meal_full}`}
            </div>
          </div>
          <div className="hotel__description">{hoteldescription}</div>
          <div className="hotel__tour">
            <Link
              className="hotel__tour-link"
              target="_blank"
              rel="noreferrer"
              onClick={handleSeen}
              to={`https://www.geograftour.com/tours/tour-info/${row.tours.tour[0].tourid}/`}
            >
              <p className="hotel__tour-link-price">
                {row_fix.row.full_price_label}{' '}
                <small>{CURRENCY_MAP_ICON[currency]}</small>
              </p>
              {row.tours.tour[0].hotelstatus === 2 ? (
                <span className="permanent-booking-container">
                  <BsFillLightningChargeFill
                    className="permanent-booking-icon"
                    title="Мгновенное бронирование"
                  />
                </span>
              ) : null}
            </Link>
            <div className="hotel__tour-buttons">
              <div className="hotel__cabinet-buttons">
                <FaHeart
                  className={`like-${!!geoKeyLikedTour} hotel__cabinet-button`}
                  onClick={setTourLike}
                  title="Добавить тур в избранное"
                />
                <FaCartPlus
                  className={`cart-${!!geoKeyAddedToCartTour} hotel__cabinet-button`}
                  onClick={setTourToCart}
                  title="Добавить тур в корзину"
                />
              </div>
              <button
                type="button"
                onClick={toggleTours}
                className="hotel__open-tours-btn btn"
              >
                {isOpen ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />}
              </button>
            </div>
          </div>
        </div>
      </article>
      {isOpen ? (
        <>
          {tours.tour.length && sort === 'price' ? (
            <button
              className="tour__group-button"
              onClick={() => onSort('room')}
            >
              Группировать по типу номера
            </button>
          ) : (
            <button
              className="tour__group-button"
              onClick={() => onSort('price')}
            >
              Группировать по стоимости
            </button>
          )}
        </>
      ) : null}
      {isOpen && sort === 'room' ? (
        <TouristGroupedByRoomTours
          row_fix={row_fix}
          row={row}
          groupedTours={groupedTours}
          roomList={roomList}
          hideoperator={request_model.hideoperator}
          onContinue={handleContinue}
          request_model={request_model}
          likes={likes}
          carts={carts}
          setTourToShare={setTourToShare}
          setOpenModal={setOpenModal}
          setTourToCart={setTourToCart}
          setTourLike={setTourLike}
          handleOfficeSave={handleOfficeSave}
        />
      ) : (
        isOpen &&
        tours.tour.length && (
          <div className="hotel_hidden_list1">
            {tours.tour.map((tour) => (
              <OneTouristTour
                geoKeyLikedTour={geoKeyLikedTour}
                geoKeyAddedToCartTour={geoKeyAddedToCartTour}
                setTourToCart={setTourToCart}
                setTourLike={setTourLike}
                request_model={request_model}
                departure={departure}
                key={tour.tourid}
                isAuth={isAuth}
                onCartUpdate={onCartUpdate}
                tourData={tourData}
                likes={likes}
                carts={carts}
                row_fix={row_fix}
                row={row}
                hideoperator={request_model.hideoperator}
                tour={tour}
                setTourToShare={setTourToShare}
                handleOfficeSave={handleOfficeSave}
                setOpenModal={setOpenModal}
              />
            ))}
            {tours.tour.length > 0 ? (
              <div style={{ textAlign: 'center' }}>
                <button
                  className="btn__search-tour-more"
                  style={{ padding: '5px 10px', fontSize: 12 }}
                  onClick={handleContinue}
                >
                  Еще туры
                </button>{' '}
              </div>
            ) : null}
          </div>
        )
      )}
      {tourToShare ? (
        <ShareModal
          isMobile={true}
          row={tourToShare}
          open={isOpenModal}
          handleClose={() => {
            setOpenModal(false);
            setTourToShare(null);
          }}
        />
      ) : null}
      {loginForm && (
        <LoginForm
          show={true}
          onAuth={() => handleAuthSuccess()}
          onClose={() => {
            setLoginForm(false);
          }}
        />
      )}
    </>
  );
};

export default OneTouristHotelMobileView;
